@if (icon(); as lk) {
  @if (lk.clickable) {
    <button
      type="button"
      class="hd-gate-locks-keys-icon__button"
      [title]="lk.tooltip"
      [attr.aria-label]="lk.tooltip"
      data-test-id="gate-locks-keys-icon"
      (click)="open()"
    >
      <i
        class="fas hd-gate-locks-keys-icon"
        [class.fa-lock]="lk.kind === 'lock'"
        [class.fa-key]="lk.kind === 'key'"
        [attr.data-kind]="lk.kind"
        [class.is-inactive]="!lk.active"
        aria-hidden="true"
      ></i>
    </button>
  } @else {
    <i
      class="fas hd-gate-locks-keys-icon"
      [class.fa-lock]="lk.kind === 'lock'"
      [class.fa-key]="lk.kind === 'key'"
      [attr.data-kind]="lk.kind"
      [class.is-inactive]="!lk.active"
      [title]="lk.tooltip"
      [attr.aria-label]="lk.tooltip"
      role="img"
      data-test-id="gate-locks-keys-icon"
    ></i>
  }
}
